import React, { Component } from 'react';
import { FormControl } from 'react-bootstrap';
import './AgeFormControl.scss';

const handleOnChange = (customOnChange, input) => {
  return (event) => {
    if (input) {
      input.onChange(event);
    }

    if (customOnChange) {
      customOnChange(event);
    }
  };
};

class AgeFormControl extends Component {
  render() {
    const { input, meta, rows, placeholder, disabled, onChange } = this.props;

    return (
      <div className={meta && meta.touched && meta.error ? ' has-error' : ''}>
        <FormControl
          {...input}
          placeholder={placeholder}
          rows={rows}
          disabled={disabled}
          onChange={handleOnChange(onChange, input)}
          onBlur={handleOnChange(onChange, input)}
        />

        {meta && meta.touched && meta.error && (
          <span className="input-age-error">{meta.error}</span>
        )}
      </div>
    );
  }
}

export default AgeFormControl;
